// extracted by mini-css-extract-plugin
module.exports = {"root":"p_M","headline":"p_T f_s","list":"p_bc","listItem":"p_bd","detailsWrapper":"p_bf","avatar":"p_k"};